import { HomeState } from '../types';
import { createSlice } from '@reduxjs/toolkit';

const initialState : HomeState = {
	loading: false,
	loaded: false,
	brandsByL1: null,
};

const homeSlice = createSlice({
	name: 'home',
	initialState: initialState,
	reducers: {
		set: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
});

export const { set } = homeSlice.actions;

export default homeSlice.reducer;